#import "@/apollo/fragments/Comment.gql"

fragment Annotation on Annotation {
    _id
    author
    comments {
        ...Comment
    }
    created
    description
    modified
    status
    timeline
    type
    user
    xpos
    ypos
}
